import Message from "@/(front-desk)/components/Message"
import Markdown from 'react-markdown'
import dayjs from "dayjs"

export default function StageMessages(props) {

    const { stage, project, className } = props
    const messageClass = `mb-0 w-fit !shadow-none ${className}`
    const projectFileLength = project?.filepacks?.[stage?.shortcut]?.length
    const totalFilesToUpload = stage?.shortcut === 'certificate-upload' ?
        project?.booth_size_approved?.includes('g') ? 1 : 2 : stage?.doctypes?.length
        // stage certificate-upload 檢查展出大小所需要上傳的憑證數量

    if (stage) return (
        <>
        { project?.reviews?.[stage.shortcut]
            ? <>
                <Message
                    type="error"
                    className={messageClass}
                    display={project.reviews[stage.shortcut].result === 'fail'}
                >   
                    { project.reviews[stage.shortcut].patch
                        ?
                        <>
                        { project.reviews[stage.shortcut].patch_until
                            ?
                            `您的${stage.name}審核不通過，請參考以下審查意見，於 ${dayjs(project.reviews[stage.shortcut].patch_until).format('YYYY/MM/DD')} 前進行補件修正。`
                            :
                            <>
                            { project.reviews[stage.shortcut].memo
                                ? `您的${stage.name}審核不通過，請參考以下審查意見進行補件修正。`
                                : `您的${stage.name}審核不通過。`
                            }
                            </>
                        }
                        </>
                        :
                        `您的${stage.name}審核不通過。如有疑義請聯繫展覽小組。`
                    }
                    <Markdown>{project.reviews[stage.shortcut].memo}</Markdown>
                </Message>
                <Message
                    type="success"
                    className={messageClass}
                    display={project.reviews[stage.shortcut].result === 'pass'}
                >恭喜，您的{stage.name}已通過！</Message>
            </>
            :
            <>
            <Message
                type="default"
                className={messageClass}
                display={
                    stage.needs_review &&
                    stage.current_status === 'ongoing' &&
                    (
                        (stage.shortcut === 'registration' && totalFilesToUpload > projectFileLength) ||
                        (stage.shortcut !== 'registration' && projectFileLength > 0 && totalFilesToUpload > projectFileLength)
                    )
                }
            >您的{stage.name}尚未完成！</Message>
            <Message
                type="error"
                className={messageClass}
                display={
                    project &&
                    !project.reviews[stage.shortcut] &&
                    projectFileLength === 0 &&
                    stage.current_status === 'done' &&
                    stage.needs_review
                }
            >申請已截止，尚未收到申請資料</Message>
            </>
        }
        </>
    )
}